import type { OpeningHours } from 'lib-shared-types-api';
import moment from 'moment-timezone';
import { v4 as uuid } from 'uuid';

import { defaultTime, getDateAsUTC } from 'utils/date';

import { getLocalDate } from '../../../utils/date';

export const getDefaultRegularOpeningHours = (
  agentName: string,
): OpeningHours[] =>
  [...Array(7)].map((_item, index) => {
    const localDate = getLocalDate();
    const date = localDate.clone().add(index, 'days');
    // 'Monday', 'Tuesday', 'Wednesday', etc.
    const weekDay = date.format('dddd');
    // If moment().day() evaluates as 0 (Sunday), we override the value to 7
    const dayOfWeek = date.day(weekDay).day() || 7;
    const isWeekend = dayOfWeek >= 6;

    return {
      created_at: moment().toISOString(),
      created_by: agentName,
      duration: 1,
      id: uuid(),
      intervals: isWeekend ? [] : [{ ...defaultTime }],
      name: weekDay,
      opening_hour_type: 'regular',
      recurring: { day_of_week: dayOfWeek },
      start_date: getDateAsUTC(date).toISOString(),
    };
  });
